import React from "react";
import { Box, TextField } from "@mui/material";

const LargeTextFormSimple = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  value,
  handleChange,
  handleBlur,
}) => {
  return (
    <Box xs={12} key={orderFormFieldKey} sx={{}}>
      <TextField
        id={orderFormFieldKey}
        name={orderFormFieldKey}
        sx={{ width: "100%" }}
        variant="outlined"
        multiline
        rows={4}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        error={orderFormFieldTouched && Boolean(orderFormFieldError)}
        helperText={(orderFormFieldTouched && orderFormFieldError) || " "}
      />
    </Box>
  );
};

export default LargeTextFormSimple;
